module.exports = __webpack_public_path__ + "static/img/logoFrogBlack.c1956a9.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/logo/logoFrogBlack.png
// module id = y3H2
// module chunks = 1